import React from "react";
import { ProducersDetailsListLoaderTemplate } from "themes/common/components/producer";

function ProducersDetailsListLoader(props) {
    return <ProducersDetailsListLoaderTemplate {...props} />;
}

export default ProducersDetailsListLoader;
